var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu-item',{attrs:{"index":_vm.getPath}},[_c('router-link',{attrs:{"to":_vm.getPath}},[_c('span',[_vm._v(_vm._s(_vm.nav.label)+" "+_vm._s(_vm.suffix))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }